<app-toolbar-search></app-toolbar-search>
<div class="link-expired-container">
  <h1 class="title">{{ 'LinkExpiredTitle' | translate }}</h1>
  <p class="subtitle">{{ 'LinkExpiredMessage' | translate }}</p>

  <form class="code-form" *ngIf="form" [formGroup]="form">
    <app-shared-form-code-challenger
      formControlName="code"
      name="code"
    ></app-shared-form-code-challenger>

    <div class="error-message" *ngIf="errorMessage">
      {{ errorMessage | translate }}
    </div>

    <button
      class="submit-btn"
      mat-flat-button
      [disabled]="isLoading || form.invalid"
      (click)="submit()"
    >
      <ng-container *ngIf="!isLoading">{{ 'Continue' | translate }}</ng-container>
      <ng-container *ngIf="isLoading">
        <mat-spinner diameter="20"></mat-spinner> {{ 'Loading...' | translate }}
      </ng-container>
    </button>

    <button
      class="resend-code"
      color="primary"
      [disabled]="!sendCodePermission && lastSendTime !== null"
      (click)="resendCode()"
    >
      <ng-container *ngIf="!sendCodePermission && lastSendTime !== null; else openToSend">
        {{ 'WaitSeconds' | translate: { seconds: getDiffLastTimeAndNowInSec() } }}
      </ng-container>
      <ng-template #openToSend>
        <ng-container *ngIf="!isLoading">
          <mat-icon>autorenew</mat-icon>
          <span>{{ 'Resendcode' | translate }}</span>
        </ng-container>
        <ng-container *ngIf="isLoading">
          <mat-spinner diameter="20"></mat-spinner> {{ 'Loading...' | translate }}
        </ng-container>
      </ng-template>
    </button>
  </form>
</div>
